import * as React from 'react';
import { IOutput } from '../../helpers';
import {
    DialogFooter,
    Button, ButtonType,
    TextField,
    Dropdown, IDropdownOption,
    Toggle
} from 'office-ui-fabric-react';
import { DropdownTabbed } from '../index';

interface IProps {
    closeDialog: (save: boolean) => void;
    journeyTypes: IDropdownOption[];
    journeyTypeChange: (item: IDropdownOption) => void;
    selectedJourneyType: string;
}

export class JourneyTypeDialog extends React.Component<IProps, any> {
    
    public render () {

        let { closeDialog, journeyTypes, journeyTypeChange, selectedJourneyType } = this.props;

		return <div>
            <DropdownTabbed
                tabIndex={1}
                required={true}
                label='Journey type:'
                options={ journeyTypes }
                onChanged={ journeyTypeChange } 
                selectedKey={ selectedJourneyType }
                className="type-selector"
            />
            <DialogFooter>
                <Button buttonType={ ButtonType.primary } onClick={ () => closeDialog(true) }>Save</Button>
            </DialogFooter>
        </div>;

	}
}


// WEBPACK FOOTER //
// ./source/ts/components/layout/journey-type-dialog.tsx